var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReviewsIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.972,
    height: 20.993,
    viewBox: "0 0 21.972 20.993",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ReviewsIcon",
    d: "M12,17.75,5.828,21l1.179-6.873-5-4.867,6.9-1L11.993,2l3.086,6.253,6.9,1-5,4.867L18.158,21Z",
    transform: "translate(-1.007 -1.002)",
    fill: "none",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewsIconDark);
export default __webpack_public_path__ + "static/media/ReviewsIconDark.808d7a475d68913a9fa9174e15ac6dd5.svg";
export { ForwardRef as ReactComponent };